// @flow
import BillboardCoreByDefault from 'components/billboard/BillboardCoreByDefault';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/billboard/BillboardCoreByDefault';

const mapStateToProps = (state: StateType): StateProps => ({
  home_bloc_boutique: state.settingsState.home_bloc_boutique,
  liste_blocs_un: state.settingsState.liste_blocs_un,
  liste_blocs_deux: state.settingsState.liste_blocs_deux,
  partenaires: state.settingsState.partenaires,
  titre_liste_blocs_un: state.settingsState.titre_liste_blocs_un,
  titre_liste_blocs_deux: state.settingsState.titre_liste_blocs_deux
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BillboardCoreByDefault);
